import { Injectable } from '@angular/core';
import { AppStates, AppStateService } from './appStateService';

@Injectable({ providedIn: 'root' })
export class LayoutService {
    constructor(private readonly _appStateService: AppStateService) {
        _appStateService.appState$.subscribe((state) => {
            const checkState = (states: AppStates[]) => states.indexOf(state) >= 0;
            const appStates = _appStateService.appStates;

            this.showApp = checkState([appStates.Initialized, appStates.LoggedIn]);
            this.showMenu = checkState([appStates.Initialized, appStates.LoggedIn, appStates.LoggingOut]);
            this.showQuick = checkState([appStates.LoggedIn]);
            this.loggedOut = checkState([appStates.LoggingOut, appStates.LoggedOut]);
        });
    }

    showApp: boolean;
    showMenu: boolean;
    loggedOut: boolean;
    showQuick: boolean;
}
